import { format, isValid, parseISO } from 'date-fns'

export function safeFormatKnockStatusTimestamp(
  time?: string | Date | null,
): string | null {
  if (!time) return null

  try {
    let dateObj: Date
    if (typeof time === 'string') {
      // Try parsing as ISO string first, then as generic date
      const parsed = parseISO(time)
      dateObj = isValid(parsed) ? parsed : new Date(time)
    } else {
      dateObj = time
    }

    if (!isValid(dateObj)) {
      return null
    }

    // Guard against sentinel/default timestamps. The backend can emit an
    // unhydrated knock-status stub whose CreatedTime defaults to
    // DateTime.MinValue (0001-01-01), which is a "valid" date but not a real
    // one — it must not render as "Dec 31, 0001, HH:mm". Any pre-1970 value is
    // treated as absent (no knock status predates the product).
    if (dateObj.getFullYear() < 1970) {
      return null
    }

    return format(dateObj, 'MMM d, yyyy, HH:mm')
  } catch {
    return null
  }
}

// SH-1307 -- "View Knock Status History" is only viewable when there's more than
// one entry, or exactly one entry with nothing currently active (SH-1184 requires
// a single still-active status to stay hidden here, since there's nothing extra
// to view beyond what's already shown).
export function hasViewableHistory(
  count: number,
  hasActiveStatus: boolean,
): boolean {
  return count > 1 || (count === 1 && !hasActiveStatus)
}

export function formatKnockStatusCreatedInfo(
  createdTime?: string | Date | null,
  createdByName?: string | null,
): string | null {
  const timeText = safeFormatKnockStatusTimestamp(createdTime)
  if (!timeText) return null

  const authorText = createdByName?.trim()
  return authorText ? `${timeText} - ${authorText}` : timeText
}
